module.exports = __webpack_public_path__ + "static/img/logo8.83b4653.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo8.png
// module id = 7iwe
// module chunks = 19